var POPUP = POPUP || {};

var hasPopupCallback = false;

var setDiscountAlertViewMode = function(timerViewMode){
	if(DiscountAlertViewMode.CountDown === timerViewMode){
		$('div#discountAlert').show();

		$('#discountAlertContentTimer').show();
		$('#discountAlertContentSuccess').hide();
		$('#discountAlertContentFail').hide();
	} else if(DiscountAlertViewMode.CouponSuccess === timerViewMode){
		$('div#discountAlert').show();

		$('#discountAlertContentTimer').hide();
		$('#discountAlertContentSuccess').show();
		$('#discountAlertContentFail').hide();
		$('#close-discount').show();
	} else if(DiscountAlertViewMode.CouponFail === timerViewMode){
		$('div#discountAlert').show();

		$('#discountAlertContentTimer').hide();
		$('#discountAlertContentSuccess').hide();
		$('#discountAlertContentFail').show();
		$('#close-discount').show();
	}
};

//Price detail ekranında reservation ve commonpayment da kullanılır campaignCallback
POPUP.campaignCallback = function(){
	
	var popupCampaignOkCallback = null;
	this.popupCampaignOkCallback = popupCampaignOkCallback;
	
	$("a#btnPopupCampaign").click(function() {
		var couponCode = $.cookie('publicCouponCode');
		if(couponCode) {
			if(self.popupCampaignOkCallback){//callback metot set edildiyse, butona basıldığında yapılması gereken işleri çağıran yere bırakıyoruz.
				self.popupCampaignOkCallback(couponCode);
				hasPopupCallback = false;
			} else {
				showTimer();
			}
		}
	});

	var showTimer = function(){
		var couponCode = $.cookie('publicCouponCode');
		if(couponCode) {
			$('#discountAlertCouponCode').text(couponCode);
			setDiscountAlertViewMode(DiscountAlertViewMode.CountDown);
		}
	};
	
	var isCampaignActive = function(){
		var isCampaignAccepted = ($.cookie('isCampaignAccepted') == 'true');
		return isCampaignAccepted;
	};
	
	var setPopupCampaignOkCallback = function(callback){
		self.popupCampaignOkCallback = callback;
		hasPopupCallback = true;
	};
	
	var showCouponSuccessMessage = function(){
		self.setDiscountAlertViewMode(DiscountAlertViewMode.CouponSuccess);
	};
	
	var showCouponFailMessage = function(){
		self.setDiscountAlertViewMode(DiscountAlertViewMode.CouponFail);
	};
	
	var getCachedCouponCode = function(){
		return $.cookie('publicCouponCode');
	};
	
	return {
		showCouponSuccessMessage:showCouponSuccessMessage,
		showCouponFailMessage:showCouponFailMessage,
		isCampaignActive:isCampaignActive,
		setPopupCampaignOkCallback:setPopupCampaignOkCallback,
		getCachedCouponCode:getCachedCouponCode,
	};
};

POPUP.campaign = function(couponCode, couponCodeId, discountMessage, displayPageName, couponSource){
	
	var isAgentMobile = window.navigator.userAgent.match("Mobi");
	if(isAgentMobile)
		return;
	
	var self = this;

	//constants
	var POPUP_LOCK_TIME_IN_MILISECONDS = 3*1000; //3 seconds
	var COUPON_TIMER_IN_SECONDS = 6*60*60; //6 hours
	var CACHE_TIME_IN_MILISECONDS = COUPON_TIMER_IN_SECONDS*1000;
	this.CACHE_TIME_IN_MILISECONDS = CACHE_TIME_IN_MILISECONDS;
	this.COUPON_TIMER_IN_SECONDS = COUPON_TIMER_IN_SECONDS;
	
	var lockPopup = true;
	this.lockPopup = lockPopup;
	
	//Private functions
	this.saveStateOfProperty = function(propertyName, value, time){
		if(time){
			$.cookie(propertyName, value, { expires : time, path: '/'});
		} else if(self.startTimeInSeconds && self.startTimeInSeconds > 0){
			var expireTime = new Date();
			expireTime.setTime(expireTime.getTime() + (self.startTimeInSeconds*1000));
			$.cookie(propertyName, value, { expires : expireTime, path: '/'});
		} else {
			var expireTime = new Date();
			expireTime.setTime(expireTime.getTime() + self.CACHE_TIME_IN_MILISECONDS);
			$.cookie(propertyName, value, {expires: expireTime, path: '/'});
		}
	};
	
	this.resetCouponCacheToDefault = function(couponCode, couponCodeId, discountMessage, couponSource, displayPageName){
		var now = new Date();
		var time = now.getTime() + self.CACHE_TIME_IN_MILISECONDS;
		now.setTime(time); 
		
		self.saveStateOfProperty('publicCouponCode', couponCode, now);
		self.saveStateOfProperty('publicCouponCodeId', couponCodeId, now);
		self.saveStateOfProperty('discountMessage', discountMessage, now);
		self.saveStateOfProperty('couponSource', couponSource, now);
		self.saveStateOfProperty('displayPageName', displayPageName, now);

		self.saveStateOfProperty('didCouponPopupSuggest', false, now);
		self.saveStateOfProperty('isCampaignAccepted', false, now);
		self.saveStateOfProperty('isCampaignRejected', false, now);
		self.saveStateOfProperty('publicCouponTime', self.COUPON_TIMER_IN_SECONDS, now);
		$.cookie('couponDisplayTime', null, {path: '/'});

	};
	
	this.deleteCouponCache = function(){
		$.cookie('publicCouponCode', null, {path: '/'});
		$.cookie('publicCouponCodeId', null, {path: '/'});
		$.cookie('discountMessage', null, {path: '/'});
		$.cookie('couponSource', null, {path: '/'});
		$.cookie('displayPageName', null, {path: '/'});

		$.cookie('didCouponPopupSuggest', null, {path: '/'});
		$.cookie('isCampaignAccepted', null, {path: '/'});
		$.cookie('isCampaignRejected', null, {path: '/'});
		$.cookie('publicCouponTime', null, {path: '/'});
		$.cookie('couponDisplayTime', null, {path: '/'});

	};
	
	this.openPopupLock = function(){
		self.lockPopup = false;
	};
	
	this.addCouponPopupDisplayLog = function(couponCodeId, couponSource, displayPageName){
		$.ajax({
			type : "POST",
			async : true,
			url : "/addCouponPopupDisplayLog",
			data : {
				couponCodeId: couponCodeId,
				displayPageName: displayPageName,
				source: couponSource
			},
			dataType : 'json',
			success : function(response) {},
			error : function(xhr, ajaxOptions, errorThrown) {}
		});
	}
	
	setTimeout(this.openPopupLock, POPUP_LOCK_TIME_IN_MILISECONDS);// 3 seconds delay
	
	//initialize state
	var cachedCouponCode = $.cookie('publicCouponCode');
	var cachedCouponCodeId = $.cookie('publicCouponCodeId');
	var cachedCouponTime = $.cookie('publicCouponTime');
	var cachedDiscountMessage = $.cookie('discountMessage');
	var cachedCouponSource = $.cookie('couponSource');
	var cachedPageName = $.cookie('displayPageName');

	if(couponCode){ //Kupon kodu ile sadece content ve ana sayfadan gelir. Yani source üzerinden.
		if(!cachedCouponTime || cachedCouponTime == 0){ //Kullanıcı tekrar source üzerinden geldiğinde aynı kupon dahi olsa tekrar gösterebilmek için cache i siliyoruz.
			this.resetCouponCacheToDefault(couponCode, couponCodeId, discountMessage, couponSource, displayPageName);
		} else {
			this.saveStateOfProperty('publicCouponCode', couponCode);
			this.saveStateOfProperty('publicCouponCodeId', couponCodeId);
			this.saveStateOfProperty('discountMessage', discountMessage);
			this.saveStateOfProperty('couponSource', couponSource);
		}
	} else if(cachedCouponCode){
		if(!cachedCouponTime || cachedCouponTime == 0){ //Kullanıcı source ile gelmez ise ve zaman sıfırlandıysa cache i komple siliyoruz.
			this.deleteCouponCache();
		} 
		
		couponCode = cachedCouponCode;
		couponCodeId = cachedCouponCodeId;
		discountMessage = cachedDiscountMessage;
		couponSource = cachedCouponSource;
	}
	
	if(displayPageName){
		this.saveStateOfProperty('displayPageName', displayPageName);
	} else {
		displayPageName = cachedPageName;
	}
	
	//update variables from cache
	var isCampaignAccepted = ($.cookie('isCampaignAccepted') == 'true');
	var isCampaignRejected = ($.cookie('isCampaignRejected') == 'true');
	var popupCampaignSuggested = ($.cookie('didCouponPopupSuggest') == 'true');
	var cachedCouponCode = $.cookie('publicCouponCode');
	var cachedCouponCodeId = $.cookie('publicCouponCodeId');
	var cachedCouponTime = $.cookie('publicCouponTime');
	var popupCampaignOkCallback = null;
	
	//set this to reach properties from functions
	this.isCampaignAccepted = isCampaignAccepted;
	this.isCampaignRejected = isCampaignRejected;
	this.popupCampaignOkCallback = popupCampaignOkCallback;
	this.popupCampaignSuggested = popupCampaignSuggested;
	this.couponCode = couponCode;
	this.couponCodeId = couponCodeId;
	this.discountMessage = discountMessage;
	this.couponSource = couponSource;
	this.displayPageName = displayPageName;
	this.startTimeInSeconds = cachedCouponTime;
	
	//events
	$('#popupCampaign').dialog({
		autoOpen: false,
		modal: true,
		show: "fade",
		hide: "fade",
		dialogClass : 'popup-campaign',
		resizable: false,
		width: 600,
		height: 320
	});

	$("#header").mouseover(function(e) { 
	   if (self.lockPopup)
			return;
	   
	   if (self.couponCode && !self.isCampaignAccepted && !self.isCampaignRejected) {
		   	self.popupCampaignSuggested = true;
			self.saveStateOfProperty('didCouponPopupSuggest', self.popupCampaignSuggested);

			$("#popupCampaign #discountMessage").html(self.discountMessage);
	   	 	$("#popupCampaign").dialog('open');
	   	 	
	   	 	self.addCouponPopupDisplayLog(self.couponCodeId, self.couponSource, self.displayPageName);
	   }
	});
			
	$("a#btnPopupCampaign").click(function() {
		$('#popupCampaign').dialog('close');
		self.isCampaignAccepted = true;
		self.isCampaignRejected = false;
		self.saveStateOfProperty('isCampaignAccepted', self.isCampaignAccepted);
		self.saveStateOfProperty('isCampaignRejected', self.isCampaignRejected);
		
		var couponDisplayTime = (new Date()).getTime();
		self.saveStateOfProperty('couponDisplayTime', couponDisplayTime);
		
		if(!hasPopupCallback){
			showTimer();
		}
		startTimer();
	});
	
	//popup close event
	$("div.popup-campaign  button.ui-dialog-titlebar-close").click(function(){
		self.isCampaignRejected = true;
		self.saveStateOfProperty('isCampaignRejected', self.isCampaignRejected);
	});
	
	//Public functions
	var clock;
	var startTimer = function(){
		
		var couponDisplayTime = $.cookie('couponDisplayTime');
		var remainingTime = 0;
		if(!couponDisplayTime || couponDisplayTime == null){
			remainingTime = self.startTimeInSeconds;
		} else {
			//Kalan süre kuponun ilk gösterim zamanına göre hesaplanıyor.
			var now = new Date();
			var remainingTime = parseInt(self.COUPON_TIMER_IN_SECONDS - (now.getTime() - couponDisplayTime)/1000, 10);
			if(remainingTime < 0) remainingTime = 0;
		}
		
		FlipClock.Lang.Local = {	
				'years'   : '<fmt:message key="reservation.popupCampaign.time.years" />',
				'months'  : '<fmt:message key="reservation.popupCampaign.time.months" />',
				'days'    : '<fmt:message key="reservation.popupCampaign.time.days" />',
				'hours'   : '<fmt:message key="reservation.popupCampaign.time.hours" />',
				'minutes' : '<fmt:message key="reservation.popupCampaign.time.minutes" />',
				'seconds' : '<fmt:message key="reservation.popupCampaign.time.seconds" />'	
			};
		
		FlipClock.Lang['local']      = FlipClock.Lang.Local;

		clock = $('.popupTimer').FlipClock({
			countdown: true,
			clockFace: 'HourlyCounter',
	        autoStart: false,
	        language:'local',
	        callbacks: {
	        	
	        	interval: function() {
	        		var time = clock.getTime().time;
					self.saveStateOfProperty('publicCouponTime', time);
					self.startTimeInSeconds = time;
	        	},
	        	stop: function() {
	        		$('.message').html('The clock has stopped!')
	        	}
	        }
	    });

	    clock.setTime(remainingTime); 
	    clock.start();
	};
	
	var showTimer = function(){
		$('#discountAlertCouponCode').text(self.couponCode);
		setDiscountAlertViewMode(DiscountAlertViewMode.CountDown);
	};

	var isCampaignActive = function(){
		return self.isCampaignAccepted;
	};
	

	
	var resetCampaignPopup = function(){
		self.deleteCouponCache();
	};
	
	return {
		showTimer:showTimer,
		startTimer:startTimer,
		isCampaignActive:isCampaignActive,
		resetCampaignPopup:resetCampaignPopup		
	};
};
var DiscountAlertViewMode ={CountDown: 1, CouponSuccess: 2, CouponFail: 3};

